export default "__VITE_ASSET__qO0ck5z9__"